var alignmentStyle = {"alignLeft":"SK33I","textWrapNowrap":"Dbty6","alignRight":"HOXZF","alignCenter":"bKt6h","sizeFullWidth":"QXoTo","renderedInTable":"hiuFn","sizeOriginal":"sLRxI","sizeContent":"RnyvN","sizeSmall":"glyKf","sizeSmallCenter":"_8lYSU","flex":"tTrNz","LEFT":"n6AlI","CENTER":"q3lJX","RIGHT":"zSJPB","AUTO":"Ebzvs","JUSTIFY":"-jVYM"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-a3ac7a5b.js.map
